const statesData = {
  AZ: "Arizona",
  AL: "Alabama",
  AK: "Alaska",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  AS: "American Samoa",
  GU: "Guam",
  MP: "Northern Mariana Islands",
  PR: "Puerto Rico",
  VI: "U.S. Virgin Islands",
  UM: "U.S. Minor Outlying Islands",
  AB: "Alberta",
  ENG: "England",
  BC: "British Columbia",
  ON: "Ontario",
  NS: "Nova Scotia",
  NB: "New Brunswick",
  PL: "Pays de la Loire",
  JP: "Japan",
  AU: "Australia",
};

let data = [];
const dataBlocks = document.querySelectorAll("[stockists-data]");

for (const dataBlock of dataBlocks) {
  const content = JSON.parse(dataBlock.textContent);
  data = [...data, ...content];
}

class StockistsToggle extends HTMLElement {
  constructor() {
    super();

    const locations = data.filter((obj) => this.dataset.country == obj.Country);

    let states = [];

    for (const location of locations) {
      states.push(location["State/Province"]);
    }

    let statesUniq = [...new Set(states)];
    statesUniq.sort();

    console.log(this.dataset.country);
    console.log(statesUniq);

    let statesContainer = this.querySelector(".js-states");
    let stateName = this.querySelector(".js-state-name");
    let businessesContainer = this.querySelector(".js-businesses");

    for (const stateUniq of statesUniq) {
  
        statesContainer.innerHTML += `
            <li class='m-state-selector'>
                <button type='button' value='${stateUniq}' class='js-state-selector nav' data-active='false'>
                    ${stateUniq}
                </button>
            </li>
            `;
    }

    const selectors = this.querySelectorAll(".js-state-selector");

    for (const selector of selectors) {
      selector.addEventListener("click", (e) => {

        for (const sel of selectors) {
          sel.dataset.active = "false";
        }

        selector.dataset.active = "true";

        let stateLocations = locations.filter(
          (location) => location["State/Province"] == e.target.value
        );

        stateName.innerHTML = e.target.value;

        businessesContainer.innerHTML = "";

        for (const stateLocation of stateLocations) {
          const addressLine2 =
            stateLocation["Address line 2"] != ""
              ? `${stateLocation["Address line 2"]}<br>`
              : "";

          businessesContainer.innerHTML += `
                <li>
                  <div class='m-business'>
                    <div class='m-business-name nav js-business-name'>${stateLocation["Name"]}</div>
                    <div class='m-business-address small-details js-business-address'>
                        ${stateLocation["Address line 1"]}<br>
                        ${addressLine2}
                        ${stateLocation["City"]}, ${stateLocation["State/Province"]} ${stateLocation["Postal code"]}<br>
                        ${stateLocation["Country"]}
                    </div>
                  </div>
                </li>
              `;
        }
      });
    }

    if (selectors.length > 0) {
      selectors[0].click();
    }
  }
}

customElements.define("stockists-toggle-component", StockistsToggle);
